import Vue from 'vue';

let els;

if ((els = document.querySelectorAll('.others-cities')).length > 0) {
    for (let i = 0; i < els.length; i++) {
        const el = els[i];

        new Vue({
            el: el,
            name: 'OthersCities',
            data() {
                return {
                    cities: [],
                    citiesSelect: [],
                    opened: false
                };
            },
            methods: {
                getImage: window.getImage,
            }
        });
    }
}
